<script lang="ts" setup>
import { Link } from '~/types'

withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    description?: string
    link: Link
    dim?: boolean
  }>(),
  {
    title: '',
    subtitle: '',
    description: '',
  },
)
</script>

<template>
  <LinkListLargeItem :dim="!!dim" :link="link">
    <div class="headline">
      <Heading is="h4" v-if="subtitle" class="label" :data="subtitle" look="h6" />
      <Heading is="h3" v-if="title" class="title" :data="title" look="h4" />
    </div>
    <div class="description text-small" v-html="description" />
  </LinkListLargeItem>
</template>

<style lang="scss" scoped>
.item.item {
  grid-template-columns: 1fr auto;

  @include breakpoint(tl) {
    grid-template-columns: 2fr 1fr auto;
  }

  @include breakpoint(ds) {
    grid-template-columns: 2fr 1fr auto;
  }
}

.label {
  @include fluid-ts-ds(margin-bottom, 12px, 8px);
}

.title {
  margin-bottom: 0;
}

.description {
  display: none;
  color: var(--c-text-light);

  @include breakpoint(tl) {
    display: block;
  }

  > :deep(*) {
    all: unset;
  }
}
</style>
